// extracted by mini-css-extract-plugin
export default {"Overall":"MainBoard_Overall__-GRWM","MainBoard":"MainBoard_MainBoard__ebRkd"};